/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CoreProcessorModeEnum = 'DELTA' | 'HARD_REFRESH_ALL' | 'HARD_REFRESH_ORG' | 'HARD_REFRESH_SN';

export const CoreProcessorModeEnum = {

    DELTA: 'DELTA' as CoreProcessorModeEnum,

    HARD_REFRESH_ALL: 'HARD_REFRESH_ALL' as CoreProcessorModeEnum,

    HARD_REFRESH_ORG: 'HARD_REFRESH_ORG' as CoreProcessorModeEnum,

    HARD_REFRESH_SN: 'HARD_REFRESH_SN' as CoreProcessorModeEnum
};

